import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import api from "@/lib/api";

export default function OrderSuccess() {
  const { id } = useParams();
  const [order, setOrder] = useState(null);
  useEffect(() => { api.get(`/orders/${id}`).then((r) => setOrder(r.data)); }, [id]);

  return (
    <div className="max-w-3xl mx-auto px-6 py-20 text-center">
      <CheckCircle2 className="w-16 h-16 text-[#4A5759] mx-auto" />
      <div className="overline mt-6">Order confirmed</div>
      <h1 className="font-display text-4xl md:text-5xl mt-3">Thank you for gifting with Eko.</h1>
      <p className="mt-4 text-[#6C665F]">We've received your order and started preparing it with care.</p>
      {order && (
        <div className="mt-10 card-eko p-6 text-left" data-testid="order-summary">
          <div className="overline">Order ID</div>
          <div className="font-mono text-sm mt-1">{order.id}</div>
          <div className="mt-4 text-sm text-[#6C665F]">
            <div>Delivery on <span className="text-[#2D2A26] font-medium">{order.delivery_date}</span> · {order.delivery_slot}</div>
            <div className="mt-1">Payment: <span className="text-[#2D2A26] font-medium capitalize">{order.payment_method === "cod" ? "Cash on Delivery" : "Online (Paid)"}</span></div>
            <div className="mt-1">Total: <span className="text-[#2D2A26] font-semibold">₹{order.total}</span></div>
          </div>
        </div>
      )}
      <div className="mt-10 flex gap-4 justify-center">
        <Link to="/orders" data-testid="view-orders-btn" className="btn-outline">View My Orders</Link>
        <Link to="/" className="btn-primary">Continue Shopping</Link>
      </div>
    </div>
  );
}
